export default <T extends Record<string, any>>(object: T): T =>
  Object.entries(object).reduce((previous: T, current) => {
    const [key, value] = current;
    const cleanObject = { ...previous };
    if (value || value === false) {
      cleanObject[key as keyof T] = value;
    }
    return cleanObject;
  }, {} as T);
